import { IP } from 'entities/ip';
import { EntityWithId } from 'services/apiGatewayClient/interface';
import { MpsWhitelistedIPResponse } from '../types';

/**
 * Maps MPS whitelisted IP API response (Go wrapped shape) to app entity.
 */
export function mapMpsWhitelistedIPResponseToEntity(item: MpsWhitelistedIPResponse): EntityWithId<IP> {
  const value = item.value ?? { ip: '', name: '' };
  return {
    id: item.id,
    entity: {
      name: value.name,
      ip: value.ip,
      campaignId: item.parentResourceIds?.campaignId,
    },
  };
}
